import { Button, Divider, Image, Modal } from "antd";
import React from "react";
import { FaCrown } from "react-icons/fa";
import Container from "../../General/Container/Container"
import nosubscription from "../../../images/personas/PersonaIllustration.png";
import { useDispatch, useSelector } from "react-redux";
import { setVisiblePersonasModal } from "../../../store/components/Reports.slice";

function NoSubPersonasModal() {
    const dispatch = useDispatch();
    const { visiblePersonasModal: {
        visible
    } } = useSelector((state) => state.reports);

    return (<Modal
        centered
        className="nosubsmodal"
        visible={visible}
        title={null}
        footer={null}
        onCancel={() => {
            dispatch(setVisiblePersonasModal({
                data: null,
                visible: false
            }));
        }}
    >
        <Container className="drow fullscreen gap-2">
            <Container className="nosubsmodal-textside dcol gap-3">
                <Container className="dcol align-center">
                    <Container className="drow align-center gap-1 justify-center">
                        <span className="nosubsmodal-title">
                            Try ONE Intelligence
                        </span>
                        <span className="nosubsmodal-titletag">
                            PRO
                        </span>
                    </Container>
                    <span className="nosubsmodal-subtitle text-center">
                        And get the advanced feature of these Personas.
                    </span>
                    <Divider style={{ width: "45%", minWidth: 0, borderTopWidth: "3px" }} />
                </Container>
                <Container className="drow justify-center">
                    <Button type="primary" style={{ marginTop: "3mm" }} onClick={() => {
                        window.open("mailto: onemarket@sqreem.com")
                    }}>
                        <FaCrown style={{ marginRight: "2mm" }} />
                        <span>Upgrade Plan</span>
                    </Button>
                </Container>
            </Container>
            <Container className="nosubsmodal-imageside dcol">
                <Image src={nosubscription} preview={false} />
            </Container>
        </Container>
    </Modal>
    );
}

export default NoSubPersonasModal;
